import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { COLOR_PRIMARY, COLOR_PRIMARY_DARK } from "../../styles/colors";
import TrafficPatternIcon from "../common/TrafficPatternIcon";
import { TrafficPatterns } from "../../models/traffic-patterns";
import { getCompactNumberStr } from "../../utils/iops-utils";
import EditIcon from "@mui/icons-material/Edit";
import CountUp from "react-countup";

interface IOPSDisplayProps {
  totalIOPS: number;
  readPct: number;
  writePct: number;
  trafficPattern: TrafficPatterns | null;
  isMobile: boolean;
  gameIsRunning?: boolean;
  onClick?: () => void;
  id?: string;
}

const IOPSDisplay: React.FC<IOPSDisplayProps> = ({
  totalIOPS,
  readPct,
  writePct,
  trafficPattern,
  isMobile,
  gameIsRunning,
  onClick,
  id,
}) => {
  return (
    <Box
      id={id}
      onClick={onClick}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: isMobile ? 1 : 1.5,
        color: COLOR_PRIMARY,
        border: `1px solid ${COLOR_PRIMARY}`,
        borderRadius: "8px",
        padding: isMobile ? "7px 6px" : "7px 10px",
        height: isMobile ? "28px" : "35px",
        flexGrow: 1,
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: "rgba(21, 118, 152, 0.08)",
          borderColor: COLOR_PRIMARY_DARK,
          color: COLOR_PRIMARY_DARK,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: isMobile ? 1 : 2,
        }}
      >
        {trafficPattern && (
          <TrafficPatternIcon pattern={trafficPattern} color="inherit" />
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: "bold",
              lineHeight: 1,
              marginBottom: "3px",
              fontSize: isMobile ? "0.7rem" : undefined,
            }}
          >
            Total TPS:{" "}
            {/* CountUp renders NaN with a zero duration, so show the plain value while paused */}
            {gameIsRunning ? (
              <CountUp
                end={totalIOPS}
                duration={2}
                formattingFn={getCompactNumberStr}
                preserveValue
              />
            ) : (
              getCompactNumberStr(totalIOPS)
            )}
          </Typography>
          <Typography
            variant="caption"
            sx={{ fontSize: isMobile ? "0.6rem" : "0.7rem", lineHeight: 1 }}
          >
            Read: {readPct}% Write: {writePct}%
          </Typography>
        </Box>
      </Box>
      <EditIcon
        sx={{
          fontSize: isMobile ? "12px" : "16px",
          opacity: 0.6,
          marginLeft: "8px",
        }}
      />
    </Box>
  );
};

export default IOPSDisplay;

